/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceScheduleTemplateItem
 */
export interface DeviceScheduleTemplateItem {
    /**
     *
     * @type {string}
     * @memberof DeviceScheduleTemplateItem
     */
    baseOperatingMode?: DeviceScheduleTemplateItemBaseOperatingModeEnum;
    /**
     *
     * @type {string}
     * @memberof DeviceScheduleTemplateItem
     */
    sessionOperatingMode?: DeviceScheduleTemplateItemSessionOperatingModeEnum;
    /**
     *
     * @type {number}
     * @memberof DeviceScheduleTemplateItem
     */
    setpointA?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceScheduleTemplateItem
     */
    cronExpression?: string;
    /**
     *
     * @type {number}
     * @memberof DeviceScheduleTemplateItem
     */
    durationSeconds?: number;
    /**
     * Optional description. If null, the DeviceScheduleTemplate.Description is used when applying the template.
     * @type {string}
     * @memberof DeviceScheduleTemplateItem
     */
    description?: string;
}

/**
 * @export
 */
export const DeviceScheduleTemplateItemBaseOperatingModeEnum = {
    Unknown: "Unknown",
    ExportSolar: "ExportSolar",
    AllSolar: "AllSolar",
    GridOnly: "GridOnly",
} as const;
export type DeviceScheduleTemplateItemBaseOperatingModeEnum =
    (typeof DeviceScheduleTemplateItemBaseOperatingModeEnum)[keyof typeof DeviceScheduleTemplateItemBaseOperatingModeEnum];

/**
 * @export
 */
export const DeviceScheduleTemplateItemSessionOperatingModeEnum = {
    None: "None",
    Fast: "Fast",
    Pause: "Pause",
} as const;
export type DeviceScheduleTemplateItemSessionOperatingModeEnum =
    (typeof DeviceScheduleTemplateItemSessionOperatingModeEnum)[keyof typeof DeviceScheduleTemplateItemSessionOperatingModeEnum];

/**
 * Check if a given object implements the DeviceScheduleTemplateItem interface.
 */
export function instanceOfDeviceScheduleTemplateItem(
    value: object,
): value is DeviceScheduleTemplateItem {
    return true;
}

export function DeviceScheduleTemplateItemFromJSON(
    json: any,
): DeviceScheduleTemplateItem {
    return DeviceScheduleTemplateItemFromJSONTyped(json, false);
}

export function DeviceScheduleTemplateItemFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceScheduleTemplateItem {
    if (json == null) {
        return json;
    }
    return {
        baseOperatingMode:
            json["baseOperatingMode"] == null
                ? undefined
                : json["baseOperatingMode"],
        sessionOperatingMode:
            json["sessionOperatingMode"] == null
                ? undefined
                : json["sessionOperatingMode"],
        setpointA: json["setpointA"] == null ? undefined : json["setpointA"],
        cronExpression:
            json["cronExpression"] == null ? undefined : json["cronExpression"],
        durationSeconds:
            json["durationSeconds"] == null
                ? undefined
                : json["durationSeconds"],
        description:
            json["description"] == null ? undefined : json["description"],
    };
}

export function DeviceScheduleTemplateItemToJSON(
    value?: DeviceScheduleTemplateItem | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        baseOperatingMode: value["baseOperatingMode"],
        sessionOperatingMode: value["sessionOperatingMode"],
        setpointA: value["setpointA"],
        cronExpression: value["cronExpression"],
        durationSeconds: value["durationSeconds"],
        description: value["description"],
    };
}
